import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Argument, Section } from './argument.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CONFIG } from './../../../../_config/config';
import { PolicyService } from 'src/app/_services/policy.service';

@Injectable({
  providedIn: 'root'
})

export class ArgumentService {

  gateway: any;
  url: string = "";

  constructor(private http: HttpClient, private formBuilder: FormBuilder,
              private config: CONFIG, private policyService: PolicyService) { 
    this.gateway = this.config.getGateway();
    this.url= `${this.gateway.urlQuery}/lbw/consulta`;
  }

  getPolicy(){
    return this.policyService.getPolicy();
  }

  onGetArgumnet() {
    // Deprecate:  Obtiene todos los argumentos
    //   return this.http.get(`${this.server.url}:${this.server.port}/argument/all`);
  }

  onToFormGroup(sections: Section[]): FormGroup {
    // retorna un grupo de argumentos configurados.
    const group: any = {};
    sections.forEach(section => {
      //   section.args.group.sort((a, b) => (a.usersequence > b.usersequence) ? 1 : -1);
      section.args.forEach(groups => {
        groups.group.sort((a, b) => (a.usersequence > b.usersequence) ? 1 : -1);
        groups.group.forEach(arg => {
          group[arg.argid] = ( arg.required === 'true')
            ? new FormControl(arg.defaultvalue || '', Validators.required)
            : new FormControl(arg.defaultvalue || '');
        });
      });
    });
    // return new FormGroup(group);
    return this.formBuilder.group(group);
  }

  onGetArgumentSDC(sdcid: string) {
    //  carga de datos en controles tipo combobox, list, multiselect, mediante SDC
    return this.http.get(`${this.url}/query/sdc/${sdcid}`);
  }

  onGetArgumentSQL(sql: string) {
    //  carga de datos en controles tipo combobox, list, multiselect, mediante SQL
    let object = { "sqlQuery": sql };
    return this.http.post(`${this.url}/query/datasql`, object);
  }

  onGetArgumentRefType(reftype: string) {
    //  carga de datos en controles tipo combobox, list, multiselect, mediante RefType
    return this.http.get(`${this.url}/query/refvalue/${reftype}`);
  }
}
